import React, { useState, useEffect, useRef } from 'react';
import "../../../assets/css/flightmonitor/flightmonitor.css";

import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMagnifyingGlass, faPlaneDeparture, faArrowRight, faPlaneArrival, faPlane, faPaperclip, faCircleXmark, faCalendarDays, faPencil, faDownload, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';

import arrive from '../../../assets/images/flightmonitor/arrive.png';
import departure from '../../../assets/images/flightmonitor/departure.png';
import arrow from '../../../assets/images/flightmonitor/arrow.png';
import air from '../../../assets/images/flightmonitor/air.png';
import cb2 from '../../../assets/images/flightmonitor/cb2.png';
import cb1 from '../../../assets/images/flightmonitor/cb1.png';
import AssetsIcon from '../../../assets/images/oparation.svg';
import Radown from "../../../assets/images/radown.png";
import AssetsIconw from '../../../assets/images/oparation_a.svg';

import arrive1 from '../../../assets/images/flightmonitor/arrive1.png';
import departure1 from '../../../assets/images/flightmonitor/departure1.png';
import settings from '../../../assets/images/flightmonitor/settings.png';
import activity from '../../../assets/images/flightmonitor/activity.png';
import ulds from '../../../assets/images/flightmonitor/ulds.png';
import details from '../../../assets/images/flightmonitor/details.png';
import map from '../../../assets/images/flightmonitor/map.png';
import clock from '../../../assets/images/flightmonitor/clock.png';

const FtmDetails = () => {
  const [selectedTab, setSelectedTab] = useState('details');

  const handleTabChange = (tab) => {
    setSelectedTab(tab)
  }

  return (
    <>
      <div className='prgs-pnl-tbl prgs-pnl-del'>
        <Table>
          <tbody>
            <tr>
              <td className='prs-tb'>
                {/* org-div /  */}
                <span className='prs-t org-div'>
                  <h4>In Progress</h4>
                </span>
              </td>
              <td className='arv-tb'>
                <div className='arrive'>
                  <span className='blue-cl'><h4>XX3806</h4></span>
                  <span style={{ display: 'flex', alignItems: 'center', }}><h4>05:33</h4>
                    <div className='fl_dep_icon'>
                      <FontAwesomeIcon icon={faPlaneDeparture} />
                    </div>
                  </span>
                  <span className='red-cl'><h4>05:40</h4></span>
                </div>
              </td>
              <td className='fl-de-ar'>
                <div className='arrow-r'>
                  <div className='arrow_icon'>
                    <FontAwesomeIcon icon={faArrowRight} />
                  </div>
                </div>
              </td>
              <td className='arv-tb'>
                <div className='arrive depart'>
                  <span style={{ display: 'flex', alignItems: 'center', }}><h4>06:39</h4>
                    <div className='fl_dep_icon'><FontAwesomeIcon icon={faPlaneArrival} /></div>
                  </span>
                  <span className='red-cl'><h4>06:45</h4></span>
                </div>
              </td>
              <td className='arvsyr-tb'>
                <div className='arrive syr'>
                  <span><h3>Mar 12</h3><h4>SYR</h4></span>
                </div>
              </td>
              <td className='ord-tb'>
                <div className='arrive'>
                  <span>
                    <div className='fl_dep_icon'>
                      <FontAwesomeIcon icon={faPlane} />
                    </div>
                  </span>
                </div>
              </td>
              <td className='ord-tb'>
                <div className='arrive'>
                  <span><h4>ORD</h4></span>
                </div>
              </td>
              <td>
                <div className='spt'>

                </div>
              </td>
              <td className='arnum-tb'>
                <div className='arrive cb1'>
                  <span className='arrive1'><img src={cb1} alt="My Image" /><h4>125</h4></span>
                  <span><img src={cb2} alt="My Image" /><h4>52</h4></span>
                </div>
              </td>
              <td className='rcf-tb'>
                <div className='rcf'>
                  <div>
                    <span className=''><h4>RCF</h4></span>
                    <span className='rcf-num'><h3>87</h3></span>
                  </div>
                  <div>
                    <span className=''><h4>DIS</h4></span>
                    <span className='rcf-num rcf-num-1'><h3>3</h3></span>
                  </div>
                </div>
              </td>
              <td className='fl-d-sla'>
                <div className='sla sl-grn'>
                  <span><h4>SLA</h4><h4>-02:45</h4></span>
                </div>
              </td>

            </tr>
          </tbody>
        </Table>
      </div>
      {/* <div className='prgs-pnl-tbl'>
          <Table>
            <tbody>
              <tr>
                <td className="flt-td">

                </td>
                <td className="flt-td-2">
                  <div className='prgs-pnl'>
                    <div className='prgs-pnl-l'>
                      <span className='prs-t org-div'><h4>In Progress</h4></span>
                      <div className='arrive'>
                        <span className='blue-cl'><h4>XX3806</h4></span>
                        <span><h4>05:33</h4> <div className='fl_dep_icon'>
                        <FontAwesomeIcon icon={faPlaneDeparture} />
                      </div></span>
                        <span className='red-cl'><h4>05:40</h4></span>
                      </div>
                      <div className='arrow-r'>
                        <span><div className='arrow_icon'>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div></span>
                      </div>
                      <div className='arrive depart'>
                        <span><h4>06:39</h4> <div className='fl_dep_icon'>
                        <FontAwesomeIcon icon={faPlaneArrival} />
                      </div></span>
                        <span className='red-cl'><h4>06:45</h4></span>
                      </div>
                      <div className='arrive syr'>
                        <span><h3>Mar 12</h3><h4>SYR</h4></span>
                      </div>
                      <div className='arrive'>
                        <span><div className='fl_dep_icon'>
                        <FontAwesomeIcon icon={faPlane} />
                      </div></span>
                      </div>
                      <div className='arrive'>
                        <span><h4>ORD</h4></span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className='flt-td-c'>
                  <div className='spt'>

                  </div>
                </td>
                <td className="flt-td-4">
                  <div className='prgs-pnl'>
                    <div className='prgs-pnl-c'>
                      <div className='arrive cb1'>
                        <span className='arrive1'><img src={cb1} alt="My Image" /><h4>125</h4></span>
                        <span><img src={cb2} alt="My Image" /><h4>52</h4></span>
                      </div>
                      <div className='rcf'>
                        <div>
                          <span className=''><h4>RCF</h4></span>
                          <span className='rcf-num'><h3>87</h3></span>
                        </div>
                        <div>
                          <span className=''><h4>DIS</h4></span>
                          <span className='rcf-num rcf-num-1'><h3>3</h3></span>
                        </div>
                      </div>
                      <div className='sla sl-grn'>
                        <span><h4>SLA</h4><h4>-02:45</h4></span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="flt-td">

                </td>
              </tr>
            </tbody>
          </Table>
        </div> */}
      <div className='mb-3 position-relative'>
        <button className={`exportbtn me-3${selectedTab === 'details' ? ' active' : ''}`} onClick={() => handleTabChange('details')}>
          <img src={selectedTab === 'details' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
        </button>
        <button className={`exportbtn me-3${selectedTab === 'shipment' ? ' active' : ''}`} onClick={() => handleTabChange('shipment')}>
          <img src={selectedTab === 'shipment' ? AssetsIconw : AssetsIcon} /> <span>Shipments</span>
        </button>
        <button className={`exportbtn me-3${selectedTab === 'ulds' ? ' active' : ''}`} onClick={() => handleTabChange('ulds')}>
          <img src={selectedTab === 'ulds' ? AssetsIconw : AssetsIcon} /> <span>ULDs</span>
        </button>
        <button className={`exportbtn me-3${selectedTab === 'exception' ? ' active' : ''}`} onClick={() => handleTabChange('exception')}>
          <img src={selectedTab === 'exception' ? AssetsIconw : AssetsIcon} /> <span>Exceptions</span>
        </button>
        <button className={`exportbtn me-3${selectedTab === 'activity' ? ' active' : ''}`} onClick={() => handleTabChange('activity')}>
          <img src={selectedTab === 'activity' ? AssetsIconw : AssetsIcon} /> <span>Activity Log</span>
        </button>
      </div>
      {selectedTab == 'details' &&
        <div className='tab-sec'>
          <div className='tab-con-main tab-con-div'>
            <div className='tab-origin'>
              <div className='tab-origin-head'>
                <h3>
                  <img src={arrive1} alt="Departure Icon" />
                  ORIGIN
                </h3>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Origin AIRPORT</h3>
                  <h4>Schiphol Airport (AMS)</h4>
                </div>
                <div className='ams-listright'>
                  <img src={map} alt="map Icon" />
                  <h3>Amsterdam, Netherlands</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Scheduled Departure Time (ATD)</h3>
                  <h4>03:52 AM</h4>
                </div>
                <div className='ams-listright'>
                  <img src={clock} alt="map Icon" />
                  <h3>CDT (GMT -05:00)</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Scheduled Departure Time (ATD)</h3>
                  <h4>03:52 AM</h4>
                </div>
                <div className='ams-listright'>
                  <img src={clock} alt="map Icon" />
                  <h3>CDT (GMT -05:00)</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>DEPARTURE DATE</h3>
                  <h4>16 March, 2021</h4>
                </div>
              </div>
            </div>
            <div className='tab-origin'>
              <div className='tab-origin-head'>
                <h3>
                  <img src={departure1} alt="Departure Icon" />
                  DESTINATION
                </h3>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Destination AIRPORT</h3>
                  <h4>Liege (LGG)</h4>
                </div>
                <div className='ams-listright'>
                  <img src={map} alt="map Icon" />
                  <h3>Liege (LGG)</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Scheduled Arrival Time (SAT)</h3>
                  <h4>07:51 AM</h4>
                </div>
                <div className='ams-listright'>
                  <img src={clock} alt="map Icon" />
                  <h3>EDT (GMT -04:00)</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <div className='ams-listleft'>
                  <h3>Actual Arrival Time</h3>
                  <h4>07:51 AM</h4>
                </div>
                <div className='ams-listright'>
                  <img src={clock} alt="map Icon" />
                  <h3>EDT (GMT -04:00)</h3>
                </div>
              </div>
              <div className='ams-list-div'>
                <>
                  <div className='ams-listleft'>
                    <h3>Arrival Date</h3>
                    <h4>16 March, 2021</h4>
                  </div>
                </>
              </div>
            </div>
          </div>
        </div>
      }
      {selectedTab == 'shipment' &&
        <div className='tab-sec'>
          <div className='tab-con-div'>
            <div className='search-panel shipment-search'>
              <div className='search-left'>
                <Form.Control type="text" placeholder="Search AWB" />
                <span>

                </span>
              </div>
              <div className='search-right-main'>
                <div className='frm-select'>
                  <Form.Select aria-label="Default select example">
                    <option>Status</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Form.Select>
                </div>
              </div>
            </div>
            <div className='shipment-table'>
              <Table striped="columns">
                <thead>
                  <tr>
                    <th>Statuses</th>
                    <th>Airway Bill No.</th>
                    <th>Pcs</th>
                    <th>RCF</th>
                    <th>MSCA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={3}>
                      <span className='active-stat'></span>
                      <span className="status-text"> No Status</span>
                    </td>
                    <td>999-5812 4018</td>
                    <td>145</td>
                    <td>-</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>126</td>
                    <td>-</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>126</td>
                    <td>-</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td rowSpan={7}>
                      <span className="active-stat org-stat"></span>
                      <span className="status-text">In Progress</span>
                    </td>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>
                      <span className="active-stat red-stat"></span>
                      <span className="status-text">Missing Cargo (MSCA)</span>
                    </td>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td rowSpan={2}>
                      <span className="active-stat grn-stat"></span>
                      <span className="status-text">Received from Flight (RCF)</span>
                    </td>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                  <tr>
                    <td>999-5812 4018</td>
                    <td>16</td>
                    <td>5</td>
                    <td>0</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      }
      {selectedTab == 'ulds' &&
        <div>Tab content for ULDs</div>
      }
      {selectedTab == 'exception' &&
        <div>Tab content for exception</div>
      }
      {selectedTab == 'activity' &&
        <div>Tab content for activity</div>
      }
    </>
  )
}

export default FtmDetails
